import { ResaleIntentionResponse } from '../../@types';

export function resaleIntention(payload: ResaleIntentionResponse) {
  return payload?.data || {};
}
